<div class="tabs d-flex flex-row border-shape-border user-select-none" [class.show-border]="showBorder">
  <a
    *ngFor="let tab of tabs"
    class="text-center"
    [class.tab-disabled]="disabled"
    [class.active]="isActiveTab(tab)"
    [class.text-bold]="boldText"
    [innerText]="tab | titlecase"
    (click)="changeNav(tab)"
  ></a>
</div>
